import React, { useCallback, useMemo, useState, useEffect } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { CountryMIN } from "../../assets/CountryMini";
import UsePeoductDropDown from "../Hooks/useProductSearch";
import axiosInstance from "../../Services/axiosCommon";

function FormikSelectTwo({
  classname,
  labelclassname,
  name,
  placeholder,
  onChange,
  formik,
  label,
  Options,
  disabled = false,
  customClass,
  px = "6",
  isRequired,
  width,
  FixPosition = true,
  PortalTarget = false,
  zindex = 1,
  isClear = false,
}) {
  const options = Array.isArray(Options) ? Options : [];

  const handleChange = (e) => {
    formik.handleChange({
      target: {
        value: e?.value || "",
        name: name,
      },
    });
  };

  const styles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "1px 0",
      color: "#000",
      textAlign: "left",
      fontWeight: "500",
      width: "100%",
      // zIndex: 1,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: zindex, // Keep dropdown inside container boundaries
      // position: 'absolute', // Prevent it from rendering at the top
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "8px 12px", // Default padding
      fontSize: "12px", // Default font size for small screens
      [`@media (min-width: 640px)`]: {
        fontSize: "12px", // sm breakpoint (Tailwind sm: text-sm)
      },
      [`@media (min-width: 768px)`]: {
        fontSize: "12px", // md breakpoint (Tailwind md: text-base)
      },
      [`@media (min-width: 1024px)`]: {
        fontSize: "12px", // lg breakpoint (Tailwind lg: text-lg)
      },
      [`@media (min-width: 1536px)`]: {
        fontSize: "14px", // lg breakpoint (Tailwind lg: text-lg)
      },
      color: state.isSelected ? "#fff" : "#000", // Custom colors for selected options
      backgroundColor: state.isSelected ? "#2563EB" : "#fff", // Custom background color for selected option
      ":hover": {
        color: "#fff",
        backgroundColor: "#60A5FA", // Hover state color
      },
    }),
  };

  return (
    <div className={`${width} relative sm:px-2 lg:px-${px} py-2`}>
      <label className={`${labelclassname} text-xs 2xl:text-sm`}>
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <div className="mt-1">
        <Select
          isDisabled={disabled}
          options={options}
          value={
            formik?.values?.[name] !== undefined && formik?.values?.[name] !== null && formik?.values?.[name] !== ""
              ? (options || []).find((i) => String(i?.value) === String(formik?.values?.[name])) ||
              (options || []).find((i) => String(i?.value)?.trim()?.toLowerCase() === String(formik?.values?.[name])?.trim()?.toLowerCase()) ||
              ""
              : ""
          }
          styles={styles}
          className={`${classname} text-xs 2xl:text-sm mt-2 font-medium ${disabled ? "bg-slate-100 cursor-not-allowed" : ""
            }`}
          name={name}
          onChange={onChange || handleChange}
          placeholder={placeholder}
          menuPlacement="auto"
          menuPosition={FixPosition == true ? "fixed" : "absolute"}
          menuPortalTarget={PortalTarget == true ? document.body : ""} // Render the dropdown in the body
          isClearable={isClear}
        />
      </div>
      {formik.errors[name] ? (
        <span className="text-xs font-semibold text-red-500">
          {formik.errors[name]}
        </span>
      ) : null}
    </div>
  );
}

export default FormikSelectTwo;

export function FormikSelectTwoSmall({
  classname,
  labelclassname,
  name,
  placeholder,
  onChange,
  formik,
  label,
  Options,
  disabled = false,
  customClass,
  px = "6",
  isRequired,
  width,
  FixPosition = true,
  PortalTarget = false,
  zindex = 1,
  isClear = false,
}) {
  const options = Array.isArray(Options) ? Options : [];

  const handleChange = (e) => {
    formik.handleChange({
      target: {
        value: e?.value || "",
        name: name,
      },
    });
  };

  const styles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "0 6px",
      color: "#000",
      textAlign: "left",
      fontWeight: "500",
      width: "100%",
      minHeight: "35px", // Fixed height
      height: "35px", // Ensures consistency
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: zindex,
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "8px 12px",
      fontSize: "12px",
      color: state.isSelected ? "#fff" : "#000",
      backgroundColor: state.isSelected ? "#2563EB" : "#fff",
      ":hover": {
        color: "#fff",
        backgroundColor: "#60A5FA",
      },
    }),
  };

  return (
    <div className={`${width} relative px-1 py-1`}>
      <label className={`${labelclassname} text-xs`}>
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <div>
        <Select
          isDisabled={disabled}
          options={options}
          value={(options || []).find((i) => String(i?.value) === String(formik?.values?.[name])) || ""}
          styles={styles}
          className={`${classname} text-xs font-medium ${disabled ? "bg-slate-100 cursor-not-allowed" : ""
            }`}
          name={name}
          onChange={onChange || handleChange}
          placeholder={placeholder}
          menuPlacement="auto"
          menuPosition={FixPosition ? "fixed" : "absolute"}
          menuPortalTarget={PortalTarget ? document.body : null}
          isClearable={isClear}
        />
      </div>
      {formik.errors[name] && (
        <span className="text-xs font-semibold text-red-500">
          {formik.errors[name]}
        </span>
      )}
    </div>
  );
}

export function TwoNEW({
  classname,
  labelclassname,
  name,
  placeholder,
  onChange,
  formik,
  label,
  Options,
  disabled = false,
  customClass,
  px = "6",
  isRequired,
  width,
  setSearch,
  debounceTime = 900,

  FixPosition = true,
  PortalTarget = false,

  zindex = 1,
}) {
  const options = Array.isArray(Options) ? Options : [];

  const handleChange = (e) => {
    formik.handleChange({
      target: {
        value: e.value,
        name: name,
      },
    });
  };
  const [loading, setLoading] = useState(false);

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const handleInputChange = useCallback(
    debounce(async (inputValue) => {
      const trimmedValue = inputValue.trim();
      if (trimmedValue.length >= 1) {
        setLoading(true);
        setSearch(trimmedValue);
        setLoading(false);
      } else if (inputValue.length == 0) {
        setLoading(true);
        setSearch(inputValue);
        setLoading(false);
      }
    }, debounceTime),
    [debounceTime]
  );

  const styles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "1px 0",
      color: "#000",
      textAlign: "left",
      fontWeight: "500",
      width: "100%",
      // zIndex: 1,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: zindex, // Keep dropdown inside container boundaries
      // position: 'absolute', // Prevent it from rendering at the top
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "8px 12px", // Default padding
      fontSize: "12px", // Default font size for small screens
      [`@media (min-width: 640px)`]: {
        fontSize: "12px", // sm breakpoint (Tailwind sm: text-sm)
      },
      [`@media (min-width: 768px)`]: {
        fontSize: "12px", // md breakpoint (Tailwind md: text-base)
      },
      [`@media (min-width: 1024px)`]: {
        fontSize: "12px", // lg breakpoint (Tailwind lg: text-lg)
      },
      [`@media (min-width: 1536px)`]: {
        fontSize: "14px", // lg breakpoint (Tailwind lg: text-lg)
      },
      color: state.isSelected ? "#fff" : "#000", // Custom colors for selected options
      backgroundColor: state.isSelected ? "#2563EB" : "#fff", // Custom background color for selected option
      ":hover": {
        color: "#fff",
        backgroundColor: "#60A5FA", // Hover state color
      },
    }),
  };

  return (
    <div className={`${width} relative px-${px} py-2`}>
      <label className={`${labelclassname} text-xs 2xl:text-sm`}>
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      <div className="mt-1">
        <Select
          isDisabled={disabled}
          options={options}
          value={(options || []).find((i) => String(i?.value) === String(formik?.values?.[name])) || ""}
          styles={styles}
          className={`${classname} text-xs 2xl:text-sm mt-2 font-medium ${disabled ? "bg-slate-100 cursor-not-allowed" : ""
            }`}
          name={name}
          onChange={onChange || handleChange}
          placeholder={placeholder}
          menuPlacement="auto"
          menuPosition={FixPosition == true ? "fixed" : "absolute"}
          menuPortalTarget={PortalTarget == true ? document.body : ""} // Render the dropdown in the body
          onInputChange={handleInputChange}
          isLoading={loading}
        />
      </div>
      {formik.errors[name] ? (
        <span className="text-xs font-semibold text-red-500">
          {formik.errors[name]}
        </span>
      ) : null}
    </div>
  );
}

export function TwoNEWSmall({
  classname,
  labelclassname,
  name,
  placeholder,
  onChange,
  formik,
  label,
  Options,
  disabled = false,
  customClass,
  px = "6",
  isRequired,
  width,
  setSearch,
  debounceTime = 900,

  FixPosition = true,
  PortalTarget = false,
  isClear = true,
  zindex = 1,
}) {
  const options = Array.isArray(Options) ? Options : [];

  const handleChange = (e) => {
    formik.handleChange({
      target: {
        value: e?.value || "",
        name: name,
      },
    });
  };
  const [loading, setLoading] = useState(false);

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const handleInputChange = useCallback(
    debounce(async (inputValue) => {
      const trimmedValue = inputValue.trim();
      if (trimmedValue.length >= 1) {
        setLoading(true);
        setSearch(trimmedValue);
        setLoading(false);
      } else if (inputValue.length == 0) {
        setLoading(true);
        setSearch(inputValue);
        setLoading(false);
      }
    }, debounceTime),
    [debounceTime]
  );

  const styles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "0 6px",
      color: "#000",
      textAlign: "left",
      fontWeight: "500",
      width: "100%",
      minHeight: "35px", // Fixed height
      height: "35px", // Ensures consistency
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: zindex, // Keep dropdown inside container boundaries
      // position: 'absolute', // Prevent it from rendering at the top
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "8px 12px", // Default padding
      fontSize: "12px", // Default font size for small screens
      color: state.isSelected ? "#fff" : "#000", // Custom colors for selected options
      backgroundColor: state.isSelected ? "#2563EB" : "#fff", // Custom background color for selected option
      ":hover": {
        color: "#fff",
        backgroundColor: "#60A5FA", // Hover state color
      },
    }),
  };

  return (
    <div
      className={`${width} relative px-1 py-1
     `}
    >
      {label && (
        <label className={`${labelclassname} text-xs`}>
          {label}
          {isRequired && <span className="text-red-500"> *</span>}
        </label>
      )}
      <div>
        <Select
          isDisabled={disabled}
          options={options}
          value={(options || []).find((i) => String(i?.value) === String(formik?.values?.[name])) || ""}
          styles={styles}
          className={`${classname} text-xs  font-medium ${disabled ? "bg-slate-100 cursor-not-allowed" : ""
            }`}
          name={name}
          onChange={onChange || handleChange}
          placeholder={placeholder}
          menuPlacement="auto"
          menuPosition={FixPosition == true ? "fixed" : "absolute"}
          menuPortalTarget={PortalTarget == true ? document.body : ""} // Render the dropdown in the body
          onInputChange={handleInputChange}
          isLoading={loading}
          isClearable={isClear}
        />
      </div>
      {formik.errors[name] ? (
        <span className="text-xs font-semibold text-red-500">
          {formik.errors[name]}
        </span>
      ) : null}
    </div>
  );
}

export function TwoNEWSmall2({
  classname,
  labelclassname,
  name,
  placeholder,
  onChange,
  formik,
  label,
  Options,
  disabled = false,
  customClass,
  px = "6",
  isRequired,
  width,
  setSearch,
  debounceTime = 900,

  FixPosition = true,
  PortalTarget = false,
  isClear = true,
  zindex = 1,
}) {
  const options = Array.isArray(Options) ? Options : [];

  const handleChange = (e) => {
    formik.handleChange({
      target: {
        value: e?.value || "",
        name: name,
      },
    });
  };

  const [loading, setLoading] = useState(false);

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const handleInputChange = useCallback(
    debounce((inputValue, { action }) => {
      if (action !== "input-change") return inputValue;

      const trimmed = inputValue.trim();

      setLoading(true);
      setSearch(trimmed);
      setLoading(false);

      return inputValue; // ✅ MUST return
    }, debounceTime),
    [debounceTime]
  );

  // const handleInputChange = useCallback(
  //   debounce(async (inputValue) => {
  //     const trimmedValue = inputValue.trim();
  //     if (trimmedValue.length >= 1) {
  //       setLoading(true);
  //       setSearch(trimmedValue);
  //       setLoading(false);
  //     } else if (inputValue.length == 0) {
  //       setLoading(true);
  //       setSearch(inputValue);
  //       setLoading(false);
  //     }
  //   }, debounceTime),
  //   [debounceTime]
  // );

  const styles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #e5e5e5",
      borderRadius: "10px",
      padding: "0 6px",
      minHeight: "32px",
      height: "32px",
      boxShadow: "none",
      display: "flex",
      alignItems: "center", // ✅ center vertically
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "0 6px",
      height: "32px",
      display: "flex",
      alignItems: "center", // ✅ center text
    }),

    singleValue: (provided) => ({
      ...provided,
      margin: "0",
      lineHeight: "32px", // ✅ exact match with control height
      display: "flex",
      alignItems: "center",
    }),

    placeholder: (provided) => ({
      ...provided,
      margin: "0",
      lineHeight: "32px",
      display: "flex",
      alignItems: "center",
      fontSize: "12px",
    }),

    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
    }),

    indicatorsContainer: (provided) => ({
      ...provided,
      height: "32px",
    }),

    menuPortal: (base) => ({
      ...base,
      zIndex: zindex,
    }),

    option: (provided, state) => ({
      ...provided,
      padding: "8px 12px",
      fontSize: "12px",
      color: state.isSelected ? "#fff" : "#000",
      backgroundColor: state.isSelected ? "#2563EB" : "#fff",
      ":hover": {
        color: "#fff",
        backgroundColor: "#60A5FA",
      },
    }),
  };

  return (
    <div className={`${width} relative`}>
      {label && (
        <label className={`${labelclassname} text-xs`}>
          {label}
          {isRequired && <span className="text-red-500"> *</span>}
        </label>
      )}
      <div>
        <Select
          isDisabled={disabled}
          options={options}
          // value={options.find((i) => i.value === formik.values[name]) || ""}
          value={(options || []).find((i) => String(i?.value) === String(formik?.values?.[name])) || null}
          styles={styles}
          className={`${classname} text-xs  font-medium ${disabled ? "bg-slate-100 cursor-not-allowed" : ""
            }`}
          name={name}
          onChange={onChange || handleChange}
          placeholder={placeholder}
          menuPlacement="auto"
          menuPosition={FixPosition == true ? "fixed" : "absolute"}
          menuPortalTarget={PortalTarget ? document.body : undefined}
          // menuPortalTarget={PortalTarget == true ? document.body : ""}
          onInputChange={handleInputChange}
          isLoading={loading}
        // isClearable={isClear}
        />
      </div>
      {formik.errors[name] ? (
        <span className="text-xs font-semibold text-red-500">
          {formik.errors[name]}
        </span>
      ) : null}
    </div>
  );
}

export function SelectCountry({
  classname,
  labelclassname,
  name,
  onChange,
  formik,
  isRequired,
  width,
  FixPosition = true,
  PortalTarget = false,
}) {
  const handleChange = (e) => {
    formik.handleChange({
      target: {
        value: e.value,
        name: name,
      },
    });
  };

  const styles = {
    control: (provided) => ({
      ...provided,

      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "1px 0",
      color: "#000",
      textAlign: "left",
      // fontSize:'13px',
      fontWeight: "500",
      width: "100%",
      // zIndex:0
    }),
  };
  return (
    <>
      <div className={`${width} relative px-6 py-2`}>
        <label className={`${labelclassname} text-xs 2xl:text-sm`}>
          Country
          {isRequired ? <span className="text-red-500"> *</span> : ""}
        </label>
        <div className="mt-2">
          <Select
            options={CountryMIN}
            value={
              (CountryMIN || []).find((i) => String(i?.value) === String(formik?.values?.[name])) || ""
            }
            styles={styles}
            className={`${classname} text-xs capitalize 2xl:text-sm mt-2 font-medium `}
            name={name}
            onChange={onChange || handleChange}
            placeholder={"Choose Country"}
            menuPlacement="auto"
            menuPosition={FixPosition == true ? "fixed" : "absolute"}
            menuPortalTarget={PortalTarget == true ? document.body : ""} // Render the dropdown in the body
          />
        </div>
        {formik.errors[name] ? (
          <span className="text-xs font-semibold text-red-500 ">
            {formik.errors[name]}
          </span>
        ) : null}
      </div>
    </>
  );
}

export function SelectWithError({
  classname,
  labelclassname,
  name,
  placeholder,
  onChange,
  formik,
  label,
  Options,
  disabled = false,
  customClass,
  px = "6",
  isRequired,
  width,
  ErrMessage,
  handleClick = () => { },
  FixPosition = true,
  PortalTarget = false,
}) {
  const options = Array.isArray(Options) ? Options : [];

  const handleChange = (e) => {
    console.log("sssss", e);

    formik.handleChange({
      target: {
        value: e.value,
        name: name,
      },
    });
  };

  const styles = {
    control: (provided) => ({
      ...provided,

      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "1px 0",
      color: "#000",
      textAlign: "left",
      // fontSize:'13px',
      fontWeight: "500",
      width: "100%",
      // zIndex:0
    }),
  };
  return (
    <>
      <div className={`${width} relative px-${px} py-2`}>
        <div className=" w-full flex gap-2">
          <label className={`${labelclassname} text-xs 2xl:text-sm w-[90%]`}>
            {label}
            {isRequired ? <span className="text-red-500"> *</span> : ""}
          </label>
          <p className="pl-2 text-xs font-semibold text-red-500 ">
            {ErrMessage}
          </p>

          <button
            onClick={handleClick}
            type="button"
            className="w-6  text-center h-6 cursor-pointer ml-5 bg-[#048178] flex justify-center items-center border border-solid border-white  text-white font-semibold rounded-lg "
          >
            {" "}
            +{" "}
          </button>
        </div>
        {/* <div className="flex">
        <label className={`${labelclassname} text-xs 2xl:text-sm`}>
          {label}
          {isRequired ? <span className="text-red-500"> *</span> : ""}
        </label>
        <p className="pl-2 text-xs font-semibold text-red-500 ">{ErrMessage}</p>
        </div> */}
        <div className="mt-2">
          <Select
            isDisabled={disabled ? true : false}
            options={options}
            value={(options || []).find((i) => String(i?.value) === String(formik?.values?.[name])) || ""}
            styles={styles}
            className={`${classname} text-xs capitalize 2xl:text-sm mt-2 font-medium ${disabled === true ? "bg-slate-100 cursor-not-allowed" : ""
              }`}
            name={name}
            onChange={onChange || handleChange}
            placeholder={placeholder}
            menuPlacement="auto"
            menuPosition={FixPosition == true ? "fixed" : "absolute"}
            menuPortalTarget={PortalTarget == true ? document.body : ""} // Render the dropdown in the body
          />
        </div>
        {formik.errors[name] ? (
          <span className="text-xs font-semibold text-red-500 ">
            {formik.errors[name]}
          </span>
        ) : null}
      </div>
    </>
  );
}

// export function FormikSelectWithAdd({
//   classname,
//   labelclassname,
//   name,
//   placeholder,
//   onChange,
//   formik,
//   label,
//   Options,
//   disabled = false,
//   customClass,
//   px = "6",
//   isRequired,
//   width,
//   handleClick=()=>{},
//   debounceTime = 900,
//   setSearch
// }) {

//   const options = Options;

//   const [loading, setLoading] = useState(false);

//   // Debounce function to limit API calls
//   const debounce = (func, delay) => {
//     let timer;
//     return (...args) => {
//       clearTimeout(timer);
//       timer = setTimeout(() => func(...args), delay);
//     };
//   };

//   // Handle dynamic search
//   const handleInputChange = useCallback(
//     debounce(async (inputValue) => {
//       if(inputValue) {
//         if (inputValue.length>=3) {
//           setLoading(true);
//           // const data = UsePeoductDropDown('/items/new-drop-down',inputValue)||[]; // Call API
//           // setOptions(data);
//           setSearch(inputValue);
//           setLoading(false);
//         }
//       }
//     }, debounceTime),
//     []
//   );

//   const handleChange = (e) => {
//     formik.handleChange({
//       target: {
//         value: e.value,
//         name: name,
//       },
//     });
//   };

//   const styles = {
//     control: (provided) => ({
//       ...provided,
//       border: "1px solid #e5e5e5",
//       outline: "none",
//       borderRadius: "10px",
//       padding: "1px 0",
//       color: "#000",
//       textAlign: "left",
//       fontWeight: "500",
//       width: "100%",
//       // zIndex: 0,
//     }),
//     menuPortal: (base) => ({
//       ...base,
//       zIndex: 1,  // Ensure it's above other elements
//       position: 'absolute',
//     }),
//     option: (provided, state) => ({
//       ...provided,
//       padding: "8px 12px",  // Default padding
//       fontSize: "12px",  // Default font size for small screens
//       [`@media (min-width: 640px)`]: {
//         fontSize: "12px",  // sm breakpoint (Tailwind sm: text-sm)
//       },
//       [`@media (min-width: 768px)`]: {
//         fontSize: "12px",  // md breakpoint (Tailwind md: text-base)
//       },
//       [`@media (min-width: 1024px)`]: {
//         fontSize: "12px",  // lg breakpoint (Tailwind lg: text-lg)
//       },
//       [`@media (min-width: 1536px)`]: {
//         fontSize: "14px",  // lg breakpoint (Tailwind lg: text-lg)
//       },
//       color: state.isSelected ? '#fff' : '#000',  // Custom colors for selected options
//       backgroundColor: state.isSelected ? '#2563EB' : '#fff',  // Custom background color for selected option
//       ':hover': {
//         color:'#fff',
//         backgroundColor: '#60A5FA',  // Hover state color
//       },
//     }),
//   };

//   return (
//     <div className={`${width} relative px-${px} py-2`}>
//         <div className=" w-full flex gap-2">
//         <label className={`${labelclassname} text-xs 2xl:text-sm w-[90%]`}>
//           {label}
//           {isRequired ? <span className="text-red-500"> *</span> : ""}
//         </label>
//         <button onClick={handleClick} type="button" className="w-6  text-center h-6 cursor-pointer bg-[#048178] flex justify-center items-center border border-solid border-white  text-white font-semibold rounded-lg " > + </button>

//         </div>
//       <div className="mt-2">
//         <Select
//           isDisabled={disabled}
//           options={options}
//           value={options.find((i) => i.value === formik.values[name]) || ""}
//           styles={styles}
//           menuPortalTarget={document.body} // Render the dropdown in the body
//           className={`${classname} text-xs 2xl:text-sm mt-2 font-medium ${disabled ? "bg-slate-100 cursor-not-allowed" : ""}`}
//           name={name}
//           onChange={onChange || handleChange}
//           placeholder={placeholder}
//           menuPlacement="auto"
//           menuPosition="absolute"
//           onInputChange={handleInputChange} // Handle input change
//           isLoading={loading}
//         />
//       </div>
//       {formik.errors[name] ? (
//         <span className="text-xs font-semibold text-red-500">
//           {formik.errors[name]}
//         </span>
//       ) : null}
//     </div>
//   );
// }

export function FormikSelectWithAdd({
  classname,
  labelclassname,
  name,
  placeholder,
  onChange,
  formik,
  label,
  Options,
  disabled = false,
  customClass,
  px = "6",
  isRequired,
  width,
  handleClick = () => { },
  debounceTime = 900,
  setSearch,
  FixPosition = true,
  PortalTarget = false,
}) {
  const options = Array.isArray(Options) ? Options : [];
  const [loading, setLoading] = useState(false);

  // Debounce function to limit API calls
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  // Handle dynamic search
  const handleInputChange = useCallback(
    debounce(async (inputValue) => {
      if (inputValue?.length >= 2) {
        setLoading(true);
        setSearch(inputValue);
        setLoading(false);
      }
    }, debounceTime),
    []
  );

  const handleChange = (e) => {
    formik.handleChange({
      target: {
        value: e.value,
        name: name,
      },
    });
  };

  const styles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #e5e5e5",
      borderRadius: "10px",
      padding: "1px 0",
      color: "#000",
      fontWeight: "500",
      width: "100%",
    }),
    menu: (provided) => ({
      ...provided,
      // zIndex: 1, // Keep dropdown inside container boundaries
      // position: 'absolute', // Prevent it from rendering at the top
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "8px 12px",
      fontSize: "12px",
      color: state.isSelected ? "#fff" : "#000",
      backgroundColor: state.isSelected ? "#2563EB" : "#fff",
      ":hover": {
        backgroundColor: "#60A5FA",
        color: "#fff",
      },
    }),
  };

  return (
    <div className={`${width} relative sm:px-2 lg:px-6 py-2`}>
      <div className="w-full flex gap-2">
        <label className={`${labelclassname} text-xs 2xl:text-sm w-[90%]`}>
          {label}
          {isRequired && <span className="text-red-500"> *</span>}
        </label>
        <button
          onClick={disabled ? undefined : handleClick}
          disabled={disabled}
          type="button"
          className={`w-6 h-6 bg-[#048178] text-white font-semibold rounded-lg flex items-center justify-center border border-white ${disabled ? "opacity-40 cursor-not-allowed" : "cursor-pointer"
            }`}
        >
          +
        </button>
      </div>
      <div className="mt-2">
        <Select
          isDisabled={disabled}
          options={options}
          value={(options || []).find((i) => String(i?.value) === String(formik?.values?.[name])) || ""}
          styles={styles}
          className={`${classname} text-xs 2xl:text-sm mt-2 font-medium ${disabled ? "bg-slate-100 cursor-not-allowed" : ""
            }`}
          name={name}
          onChange={onChange || handleChange}
          placeholder={placeholder}
          menuPlacement="auto" // Adjusts dropdown placement within available space
          menuPosition={FixPosition == true ? "fixed" : "absolute"}
          menuPortalTarget={PortalTarget == true ? document.body : ""}
          onInputChange={handleInputChange}
          isLoading={loading}
        />
      </div>
      {formik.errors[name] && (
        <span className="text-xs font-semibold text-red-500">
          {formik.errors[name]}
        </span>
      )}
    </div>
  );
}

export function FormikSelectWithoutAdd({
  classname,
  labelclassname,
  name,
  placeholder,
  onChange,
  formik,
  label,
  Options,
  disabled = false,
  customClass,
  px = "6",
  isRequired,
  width,
  handleClick = () => { },
  debounceTime = 900,
  setSearch,
  FixPosition = true,
  PortalTarget = false,
  isClear = true,
}) {
  const options = Options || [];

  const [loading, setLoading] = useState(false);

  // Debounce function to limit API calls
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  // Handle dynamic search
  const handleInputChange = useCallback(
    debounce(async (inputValue, actionMeta) => {
      if (setSearch && (actionMeta?.action === "input-change" || actionMeta?.action === "input-blur")) {
        setLoading(true);
        setSearch(inputValue ? inputValue.trim() : "");
        setLoading(false);
      }
    }, debounceTime),
    [setSearch, debounceTime]
  );

  const handleChange = (e) => {
    formik.handleChange({
      target: {
        value: e?.value || "",
        name: name,
      },
    });
  };

  const styles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "1px 0",
      color: "#000",
      textAlign: "left",
      fontWeight: "500",
      width: "100%",
      zIndex: 0,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 1, // Ensure it's above other elements
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "8px 12px", // Default padding
      fontSize: "12px", // Default font size for small screens
      [`@media (min-width: 640px)`]: {
        fontSize: "12px", // sm breakpoint (Tailwind sm: text-sm)
      },
      [`@media (min-width: 768px)`]: {
        fontSize: "12px", // md breakpoint (Tailwind md: text-base)
      },
      [`@media (min-width: 1024px)`]: {
        fontSize: "12px", // lg breakpoint (Tailwind lg: text-lg)
      },
      [`@media (min-width: 1536px)`]: {
        fontSize: "14px", // lg breakpoint (Tailwind lg: text-lg)
      },
      color: state.isSelected ? "#fff" : "#000", // Custom colors for selected options
      backgroundColor: state.isSelected ? "#2563EB" : "#fff", // Custom background color for selected option
      ":hover": {
        color: "#fff",
        backgroundColor: "#60A5FA", // Hover state color
      },
    }),
  };

  return (
    <div className={`${width} relative px-${px} py-2`}>
      {/* <div className=" w-full flex gap-2"> */}
      <label className={`${labelclassname} text-xs 2xl:text-sm w-[90%]`}>
        {label}
        {isRequired ? <span className="text-red-500"> *</span> : ""}
      </label>
      {/* <button onClick={handleClick} type="button" className="w-6  text-center h-6 cursor-pointer bg-[#048178] flex justify-center items-center border border-solid border-white  text-white font-semibold rounded-lg " > + </button> */}

      {/* </div> */}
      <div className="mt-2">
        <Select
          isDisabled={disabled}
          options={options}
          value={(options || []).find((i) => String(i?.value) === String(formik?.values?.[name])) || ""}
          styles={styles}
          // menuPortalTarget={document.body} // Render the dropdown in the body
          className={`${classname} text-xs 2xl:text-sm mt-2 font-medium ${disabled ? "bg-slate-100 cursor-not-allowed" : ""
            }`}
          name={name}
          onChange={onChange || handleChange}
          placeholder={placeholder}
          menuPlacement="auto"
          menuPosition={FixPosition == true ? "fixed" : "absolute"}
          menuPortalTarget={PortalTarget == true ? document.body : ""}
          onInputChange={handleInputChange} // Handle input change
          isLoading={loading}
          isClearable={isClear}
          filterOption={setSearch ? () => true : undefined}
        />
      </div>
      {formik.errors[name] ? (
        <span className="text-xs font-semibold text-red-500">
          {formik.errors[name]}
        </span>
      ) : null}
    </div>
  );
}

export function SelectProductWithError({
  classname,
  labelclassname,
  name,
  placeholder,
  onChange,
  formik,
  label,
  Options = [], // Default empty array
  disabled = false,
  customClass,
  px = "6",
  isRequired,
  width,
  ErrMessage,
  hasAddButton = true,
  handleClick = () => { },
  fetchOptions = () => { }, // New prop to fetch options via API
  debounceTime = 900, // Optional prop for debounce time
  setSearch,
  FixPosition = true,
  PortalTarget = false,
}) {
  // const [options, setOptions] = useState(Options);
  let options = Array.isArray(Options) ? Options : [];
  const [loading, setLoading] = useState(false);

  // Debounce function to limit API calls
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  // Handle dynamic search
  const handleInputChange = useCallback(
    debounce(async (inputValue) => {
      if (inputValue) {
        if (inputValue.length >= 3) {
          setLoading(true);
          // const data = UsePeoductDropDown('/items/new-drop-down',inputValue)||[]; // Call API
          // setOptions(data);
          setSearch(inputValue);
          setLoading(false);
        }
      } else if (inputValue.length == 0) {
        setLoading(true);
        setSearch(inputValue);
        setLoading(false);
      }
    }, debounceTime),
    []
  );

  const handleChange = (selectedOption) => {
    formik.handleChange({
      target: {
        value: selectedOption ? selectedOption.value : "",
        name: name,
      },
    });
  };

  const styles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "1px 0",
      color: "#000",
      textAlign: "left",
      fontWeight: "500",
      width: "100%",
    }),
  };

  return (
    <div className={`${width} relative px-${px} py-2`}>
      <div className="w-full flex gap-2">
        <label className={`${labelclassname} text-xs 2xl:text-sm w-[90%]`}>
          {label}
          {isRequired && <span className="text-red-500"> *</span>}
        </label>
        <p className="pl-2 text-xs font-semibold text-red-500">{ErrMessage}</p>
        {hasAddButton && (
          <button
            onClick={handleClick}
            type="button"
            className="w-6 text-center h-6 cursor-pointer ml-5 bg-[#048178] flex justify-center items-center border border-solid border-white text-white font-semibold rounded-lg"
          >
            +
          </button>
        )}
      </div>
      <div className="mt-2">
        <Select
          isDisabled={disabled}
          options={options}
          value={(options || []).find((i) => String(i?.value) === String(formik?.values?.[name])) || ""}
          styles={styles}
          className={`${classname} text-xs capitalize 2xl:text-sm mt-2 font-medium ${disabled ? "bg-slate-100 cursor-not-allowed" : ""
            }`}
          name={name}
          onChange={onChange || handleChange}
          placeholder={placeholder}
          menuPlacement="auto"
          menuPosition={FixPosition == true ? "fixed" : "absolute"}
          menuPortalTarget={PortalTarget == true ? document.body : ""}
          onInputChange={handleInputChange} // Handle input change
          isLoading={loading} // Show loader
        />
      </div>
      {formik.errors[name] && (
        <span className="text-xs font-semibold text-red-500">
          {formik.errors[name]}
        </span>
      )}
    </div>
  );
}

export function FormikAsyncSelect({
  classname,
  labelclassname,
  name,
  placeholder = "Search...",
  onChange,
  formik,
  label,
  url,
  disabled = false,
  px = "6",
  isRequired,
  width,
  FixPosition = true,
  PortalTarget = false,
  isClear = true,
  initialLabel = "",
  zindex = 99999,
}) {
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    const val = formik?.values?.[name];
    if (!val) {
      setSelectedOption(null);
    } else if (val && initialLabel && (!selectedOption || String(selectedOption.value) !== String(val))) {
      setSelectedOption({ value: val, label: initialLabel });
    }
  }, [formik?.values?.[name], initialLabel]);

  const loadOptions = useCallback(
    (inputValue, callback) => {
      axiosInstance
        .get(url, { params: { search: inputValue ? inputValue.trim() : "" } })
        .then((res) => {
          const rawData = Array.isArray(res.data) ? res.data : (res.data?.data || []);
          const formatted = rawData.map((item) => {
            const label = item.prNumber || item.ref || item.name || (item.bankName ? (item.accountNumber ? `${item.bankName} - ${item.accountNumber}` : item.bankName) : (item.label || item.title || item.code || String(item.id || "")));
            return {
              ...item,
              value: item.id !== undefined ? item.id : item.value,
              label: label || `Item #${item.id}`,
            };
          });
          callback(formatted);
        })
        .catch((err) => {
          console.error("FormikAsyncSelect fetch error:", err);
          callback([]);
        });
    },
    [url]
  );

  const handleChange = (selected) => {
    setSelectedOption(selected);
    if (formik) {
      formik.handleChange({
        target: {
          value: selected?.value !== undefined && selected?.value !== null ? selected.value : "",
          name: name,
        },
      });
    }
    if (onChange) {
      onChange(selected);
    }
  };

  const styles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "1px 0",
      color: "#000",
      textAlign: "left",
      fontWeight: "500",
      width: "100%",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: zindex,
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "8px 12px",
      fontSize: "12px",
      [`@media (min-width: 640px)`]: {
        fontSize: "12px",
      },
      [`@media (min-width: 768px)`]: {
        fontSize: "12px",
      },
      [`@media (min-width: 1024px)`]: {
        fontSize: "12px",
      },
      [`@media (min-width: 1536px)`]: {
        fontSize: "14px",
      },
      color: state.isSelected ? "#fff" : "#000",
      backgroundColor: state.isSelected ? "#2563EB" : "#fff",
      ":hover": {
        color: "#fff",
        backgroundColor: "#60A5FA",
      },
    }),
  };

  return (
    <div className={`${width} relative sm:px-2 lg:px-${px} py-2`}>
      {label && (
        <label className={`${labelclassname} text-xs 2xl:text-sm`}>
          {label}
          {isRequired ? <span className="text-red-500"> *</span> : ""}
        </label>
      )}
      <div className="mt-1">
        <AsyncSelect
          cacheOptions
          defaultOptions
          loadOptions={loadOptions}
          isDisabled={disabled}
          value={selectedOption}
          styles={styles}
          className={`${classname} text-xs 2xl:text-sm mt-2 font-medium ${disabled ? "bg-slate-100 cursor-not-allowed" : ""
            }`}
          name={name}
          onChange={handleChange}
          placeholder={placeholder}
          menuPlacement="auto"
          menuPosition={FixPosition ? "fixed" : "absolute"}
          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
          isClearable={isClear}
        />
      </div>
      {formik?.errors?.[name] ? (
        <span className="text-xs font-semibold text-red-500">
          {formik.errors[name]}
        </span>
      ) : null}
    </div>
  );
}
